import { useQuery, UseQueryResult } from 'react-query';
import { StaffRetrieve } from 'types';
import { client } from 'utils/api-client';

function useStaff(staffId: string | undefined): UseQueryResult<{ data: StaffRetrieve }> {
  return useQuery(['staff', staffId], () => client.get(`staff/${staffId}/`), {
    enabled: !!staffId,
  });
}

export default useStaff;
